import { CommonResponse } from '@gtpl/shared-models/masters';
import { AllStoreReturnsResponseModel, ConsumedQtyRequest, StoreReturnResponseModel } from '@gtpl/shared-models/procurement-management';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post, Req } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { UnitRequest } from '../stock/dto/unit.id.request';
import { ReturnReq } from '../store-consumption/dto/store-return-req';
import { UnitIdRequest } from '../store-consumption/dto/unit-id.request';
import { StoreReturnDTO } from './dto/store-return-dto';
import { StoreReturnRequest } from './dto/store-return.request';
import { StoreReturnsService } from './store-returns.service';

@ApiTags('Store Return')
@Controller('store-returns')
export class StoreReturnsController {
    constructor(
        private storeReturnsService: StoreReturnsService,
        private readonly applicationExceptionhandler: ApplicationExceptionHandler,

      ){}
    /**
     * 
     * @param storeReturnDTO 
     * @param isUpdate 
     * @param request 
     * @returns 
     */
    @Post('/createStoreReturn')
    async createStoreReturn(@Body() storeReturnDTO:StoreReturnDTO,@Req() request:Request): Promise<StoreReturnResponseModel> {
        try {
            // console.log(storeReturnDTO);
            return await this.storeReturnsService.createStoreReturn(storeReturnDTO, false,request);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(StoreReturnResponseModel, error)
        }
    }
    /**
     * 
     * @param storeReturnDTO 
     * @param request 
     * @returns 
     */
    @Post('/updateStoreReturn')
    async updateStoreReturn(@Body() storeReturnDTO: StoreReturnDTO,@Req() request:Request): Promise<StoreReturnResponseModel> {
        try {
        return await this.storeReturnsService.createStoreReturn(storeReturnDTO, true,request);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(StoreReturnResponseModel, error)
        }
    }
    /**
     * 
     * @param request 
     * @returns 
     */
    @Post('/getAllStoreReturns')
    async getAllStoreReturns(@Body() req:UnitIdRequest): Promise<AllStoreReturnsResponseModel> {
        try {
        return await this.storeReturnsService.getAllStoreReturns(req);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(AllStoreReturnsResponseModel, error)
        }
    }

    @Post('/getAllStoreReturnsReports')
    async getAllStoreReturnsReport(@Body() req:ReturnReq): Promise<AllStoreReturnsResponseModel> {
        try {
        return await this.storeReturnsService.getAllStoreReturnsReports(req);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(AllStoreReturnsResponseModel, error)
        }
    }
    
    @Post('/getStoreReturnById')
    async getStoreReturnById(@Body() storeReturnRequest: StoreReturnRequest): Promise<StoreReturnResponseModel> {
        try {
            return await this.storeReturnsService.getStoreReturnById(storeReturnRequest);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(StoreReturnResponseModel, err);
        }
    }

    @Post('getReturnedQty')
    async getReturnedQty(@Body() req: ConsumedQtyRequest) {
        try {
            return await this.storeReturnsService.getReturnedQty(req);
        } catch (error) {
            return error;
        }
    }
    @Post('getSoDropForStoreReturnReport')
    async getSoDropForStoreReturnReport(@Body() req: UnitRequest):Promise<CommonResponse> {
        try {
            return await this.storeReturnsService.getSoDropForStoreReturnReport(req);
        } catch (error) {
            return error;
        }
    }
    @Post('getItemSubDropForStoreReturnReport')
    async getItemSubDropForStoreReturnReport(@Body() req: UnitRequest):Promise<CommonResponse> {
        try {
            return await this.storeReturnsService.getItemSubDropForStoreReturnReport(req);
        } catch (error) {
            return error;
        }
    }
    @Post('getItemDropForStoreReturnReport')
    async getItemDropForStoreReturnReport(@Body() req: UnitRequest):Promise<CommonResponse> {
        try {
            return await this.storeReturnsService.getItemDropForStoreReturnReport(req);
        } catch (error) {
            return error;
        }
    }

}
